<template>
  <div class="accordion" role="tablist">
    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-1 class="btn-accordion text-left">¿Qué es GOX?</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>Es un programa de fidelización que te permite acumular puntos por tus compras en
          establecimientos afiliados, para ser canjeados por beneficios exclusivos.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  
    <b-card no-body class="mb-1 no-border">
          <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
            <b-button block v-b-toggle.accordion-2 class="btn-accordion text-left">¿Cómo acumulo puntos GOX?</b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body class="accordion-body">
              <b-card-text>Cada sol de compra tiene un equivalente en puntos GOX, según establecimiento afiliado.</b-card-text>
            </b-card-body>
          </b-collapse>
    </b-card>


    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-3 class="btn-accordion text-left">¿Los puntos son acumulables entre sí?</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>No, los puntos se acumulan y se canjean en cada establecimiento de manera independiente.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>




    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-4 class="btn-accordion text-left">¿Cómo gano puntos extras?</b-button>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>Tendrás varias opciones, tales como, multiplicar puntos o ganar puntos extras por tus compras,
          así como también ganar puntos extras por referir GOX a tus amigos.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>


    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-5 class="btn-accordion text-left">¿Cómo canjeo puntos GOX?</b-button>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>Puedes utilizar tus puntos GOX en los establecimientos donde los obtuviste y/o en la red de
establecimientos con convenios entre sí.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-6 class="btn-accordion text-left">¿Cómo canjeo mis cupones?</b-button>
      </b-card-header>
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>Debes activar tus cupones en la aplicación GOX y al momento de comprar debes mostrar en la
caja el código de barras o código QR para que se haga efectivo el canje.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-7 class="btn-accordion text-left">¿Puedo canjear más de una vez un mismo cupón?</b-button>
      </b-card-header>
      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>Cada cupón tiene sus propios términos y condiciones, el detalle lo encontrarás en la
descripción de cada uno de ellos.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-8 class="btn-accordion text-left">¿Por qué mis puntos se debitan cuando activo un cupón?</b-button>
      </b-card-header>
      <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>Tus puntos se debitan, pero se quedan en tu estado de cuenta como puntos retenidos. Una vez
          que canjees tu cupón estos ya se mostrarán como puntos canjeados. Si no haces efectivo el
          canje volverás a tener los puntos disponibles en tu cuenta.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-9 class="btn-accordion text-left">¿Cuándo vencen mis puntos?</b-button>
      </b-card-header>
      <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>Tus puntos vencen en 3 años contados a partir que los obtienes.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>


    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-10 class="btn-accordion text-left">¿Dónde puedo ver cuántos puntos tengo acumulados?</b-button>
      </b-card-header>
      <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>En la aplicación GOX vas a “Menú” – “Mis Puntos”.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>



    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-11 class="btn-accordion text-left">¿Tengo opción de canjear productos con mis puntos?</b-button>
      </b-card-header>
      <b-collapse id="accordion-11"  accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>Sólo podrás canjear los cupones diseñados especialmente para ti, los encontrarás en la
aplicación GOX.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>


  <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-12 class="btn-accordion text-left">¿Cómo puedo referir a mis amigos?</b-button>
      </b-card-header>
      <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>En la aplicación GOX vas a “Menú” – “Invitar amigos” – “Comparte tu código” con tus amigos y
familiares para se registren en GOX y/o se activen en algún establecimiento para ganar puntos
extra y al mismo tiempo tú ganarás.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-13 class="btn-accordion text-left">¿Dónde ingreso el código de referidos para ganar puntos y en qué establecimiento los gano?</b-button>
      </b-card-header>
      <b-collapse id="accordion-13" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>En la aplicación GOX vas a “Menú” – “Referidos”, previamente debes haber consumido en el
establecimiento indicado en el mensaje que recibiste y así ganarás automáticamente puntos
extra en dicho establecimiento.</b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>


    <b-card no-body class="mb-1 no-border">
      <b-card-header header-tag="header" class="p-1 accordion-header" role="tab">
        <b-button block v-b-toggle.accordion-14 class="btn-accordion text-left">Necesito ayuda</b-button>
      </b-card-header>
      <b-collapse id="accordion-14" accordion="my-accordion" role="tabpanel">
        <b-card-body class="accordion-body">
          <b-card-text>
            Puedes comunicarte vía correo electrónico a
            atencionalcliente@puntosgox.com y te ayudaremos lo antes posible.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: 'section-privacy-politics',
    components: {},
    data() {
      
      return {
        text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
      }
    }
  }
</script>